import React from 'react';
import PropTypes from 'prop-types';
import Translate from '../../../../utils/Translate';
import HtmlMessage from '../../HtmlMessage/HtmlMessage';
import ListElement from '../../ListElement/ListElement';
import { EmailStore } from '../../../../state/EmailStore';
import { PersonalInfoStore } from '../../../../state/PersonalInfoStore';

const ConfirmMerge = ({
  isLoading,
  onCheckBoxClick,
}) => (
  <div className="-pb-3 -pr-1 -pl-1">
    <div>
      <div>
        <p className="-eva-3-bold -eva-3-tc-gray-1 -fs-2">{Translate.message('confirm-merge.reminder.title')}</p>
      </div>
      <div className="list-container -eva-3-mt-xxlg">
        <div className="-fs-1-v2">
          <div>
            <ListElement order="1">
              <p className="-lh-1">{Translate.message('confirm-merge.reminder.list.1')}</p>
            </ListElement>
          </div>
          <div className="-eva-3-mt-sm">
            <ListElement order="2">
              <p className="-lh-1">
                <HtmlMessage
                  message={Translate.message('confirm-merge.reminder.list.2', {
                    currentEmail: PersonalInfoStore.getPrimaryEmail(),
                    joinEmail: EmailStore.getMergeableEmail(),
                  })}
                />
              </p>
            </ListElement>
          </div>
          <div className="-eva-3-mt-sm">
            <ListElement order="3">
              <p className="-lh-1">{Translate.message('confirm-merge.reminder.list.3')}</p>
            </ListElement>
          </div>
          <div className="-eva-3-mt-sm">
            <ListElement order="4">
              <p className="-lh-1">{Translate.message('confirm-merge.reminder.list.4')}</p>
            </ListElement>
          </div>
        </div>
      </div>
      <div className="-eva-3-mt-xlg -eva-3-pt-md -pr-2">
        <span className="eva-3-checkbox -lg">
          <label className="checkbox-label">
            <div className="-eva-3-valign">
              <div className="-eva-3-mr-sm">
                <span className="eva-3-checkbox">
                  <label className="checkbox-label">
                    <input
                      type="checkbox"
                      className="checkbox-tag"
                      disabled={isLoading}
                      onClick={onCheckBoxClick}
                    />
                    <i className="checkbox-check eva-3-icon-checkmark"/>
                  </label>
                </span>
              </div>
              <div>
                <span>
                  <p className="-fs-1-v2">{Translate.message('confirm-merge.reminder.checkbox')}</p>
                </span>
              </div>
            </div>
          </label>
        </span>
      </div>
    </div>
  </div>
);

ConfirmMerge.propTypes = {
  onCheckBoxClick: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default ConfirmMerge;
